import { Box } from "@mui/material";
import { Navigate } from "react-router";
import { useAppSelector } from "redux/hooks";
import { P } from "theme/typography";
import LookerEmbedView from "../admin/LookerEmbedView";
import { selectLookerReports, selectReportSliceStatus } from "redux/slices/clientLens";
import { useEffect, useState } from "react";
import RequestStatus from "redux/slices/RequestStatus";
import { LookerEmbedItem } from "generated/graphql";
import LoadingPattern from "components/LoadingPattern";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { useParams } from "react-router-dom";

const Report = () => {
  const { lensId } = useParamNumbers(["lensId"]);
  const { reportId } = useParams<{ reportId: string }>();

  // Impossible to get here without both, but typescript doesn't know that
  if (lensId === undefined || reportId === undefined) return <Navigate to="../" />;

  const reportStatus = useAppSelector(selectReportSliceStatus);
  const reports = useAppSelector(selectLookerReports);

  const [activeReport, setActiveReport] = useState<LookerEmbedItem | null | undefined>(undefined);

  useEffect(() => {
    const report =
      reports.embedItems.find((r) => r.id === reportId) ||
      reports.folders.flatMap((f) => f.embedItems).find((r) => r?.id === reportId);
    setActiveReport(report);
  }, [reportId, reports]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}>
      {/* No match found after loading reports */}
      {!activeReport && reportStatus === RequestStatus.SUCCEEDED && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
          }}>
          <P variant="xl2Bold">Report not found</P>
          <P variant="lg">
            Please select a report from the dropdown above.
            <br /> If you believe this is an error, please contact support.
          </P>
        </Box>
      )}
      {/* Loading reports */}
      {reportStatus === RequestStatus.PENDING && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}>
          <LoadingPattern />
        </Box>
      )}
      {/* Report found */}
      {activeReport && (
        <Box sx={{ width: "100%", height: "100%" }}>
          <LookerEmbedView lensId={lensId} name={activeReport.name} url={activeReport.url} />
        </Box>
      )}
    </Box>
  );
};

export default Report;
